<template>
  <div class="billDetial">
    <div class="detialInner">
      <div class="changeStatus" v-if="info.status == 0" style="background-color: #E95646">Pending</div>
      <div class="changeStatus" v-if="info.status == 1" style="background-color: #FFC215">Unpaid</div>
      <div class="changeStatus" v-if="info.status == 2" style="background-color: #82D237">Paid</div>
    </div>
    <el-scrollbar style="height: calc(100vh - 179px)">
      <div class="detail_out_box">
        <div class="innerMes">
          <el-form label-position="right" label-width="145px" :model="info">
            <div class="paneOne">
              <el-form-item label="invoice#: ">{{ info.invoice }}</el-form-item>
              <el-form-item label="Legal Co. Name:">{{info.legal_company_name}}</el-form-item>
              <el-form-item label="Phone:">{{ info.phone }}</el-form-item>
              <el-form-item label="Email:">{{ info.email }}</el-form-item>
              <el-form-item label="Period:">{{ info.period }}</el-form-item>
              <el-form-item label="Due status:">{{ info.status_desc }}</el-form-item>
              <el-form-item label="Billing Cycle:">{{ info.billing_type }}</el-form-item>
              <el-form-item label="Total:">{{ info.total }}</el-form-item>
              <el-form-item label="Payment method:">{{ info.payment_method_desc }}</el-form-item>
              <el-form-item label="Payment time:">{{ info.payment_time }}</el-form-item>
            </div>
          </el-form>
        </div>
        <div class="innerTable">
          <el-table
            :data="bill_table_data"
            style="width: 100%">
            <el-table-column
              prop="time"
              label="Day & Date"
              width="140">
            </el-table-column>
            <el-table-column
              prop="store_name"
              label="Store">
            </el-table-column>
            <el-table-column
              prop="price"
              label="Rate">
            </el-table-column>
            <el-table-column
              prop="count"
              label="QTY"
              width="50"
            >
            </el-table-column>
            <el-table-column
              prop="amount"
              label="Amount"
              width="80"
              align="right"
            >
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-bottom: 16px">
          <div class="out_btom_title">
            <div style="font-weight: bold;">Subtotal</div>
            <div>${{info.sub_total}}</div>
          </div>
          <div class="out_btom_title" style="margin: 16px 0">
            <div style="font-weight: bold;">HST (13%)</div>
            <div>${{info.tax}}</div>
          </div>
          <div class="out_btom_title" style="margin: 0 0 16px" v-if="info.stripe_cost != null">
            <div style="font-weight: bold;">Payment processing fee</div>
            <div>${{info.stripe_cost}}</div>
          </div>
          <div class="out_btom_title">
            <div style="font-weight: bold;">Total</div>
            <div style="font-size: 18px;font-weight: bold">${{info.total}}</div>
          </div>
        </div>
      </div>
    </el-scrollbar>

    <div class="botm_box" v-if="account == 0">
      <div  v-if="info.status == 0">
        <el-button type="primary" style="background-color: #1F2D42" @click="approveHandle">Approve</el-button>
      </div>
      <div v-if="info.status == 1">
        <el-button type="primary" style="background-color: #82D237" @click="recieveHandle">Receive Payment</el-button>
        <el-button type="primary" style="background-color: #FFB94C" @click="downInvoiceHandle">Download Invoice</el-button>

      </div>
      <div v-if="info.status == 2">
        <el-button type="primary" style="background-color: #FFB94C" @click="downInvoiceHandle">Download Invoice</el-button>
      </div>
    </div>
    <div class="botm_box" v-if="account == 1">
      <div v-if="info.status == 1">
        <el-button type="primary" style="background-color: #82D237" @click="manuallyPayHandle">Manually Pay</el-button>
        <el-button type="primary" style="background-color: #FFB94C" @click="downInvoiceHandle">Download Invoice</el-button>

      </div>
      <div v-if="info.status == 2">
        <el-button type="primary" style="background-color: #FFB94C" @click="downInvoiceHandle">Download Invoice</el-button>
      </div>
    </div>
<!--&lt;!&ndash;    手动付款 alert &ndash;&gt;-->
<!--    <el-dialog-->
<!--      :modal="false"-->
<!--      title="Payment method Alert"-->
<!--      :visible.sync="PayAlertDialog"-->
<!--      top="5vh"-->
<!--      width="32%"-->
<!--    >-->
<!--      <div class="pay_alert">-->
<!--        Rapidi prefers that our customers pay the amount <span style="color: #E95646">${{info.total}}</span>  via direct deposit (EFT) or E-transfer using the following methods:-->
<!--        <div style="margin: 24px 0">-->
<!--          Direct Deposit (EFT):-->
<!--          <div>{{legal_company_name }}</div>-->
<!--          <div>legal_company_name{{institution_no}}</div>-->
<!--          <div> Transit No.: {{transit_no}}</div>-->
<!--          <div>Account No.: {{account_no}}</div>-->
<!--          <div style="margin: 24px 0">E-transfer: {{e_transfer_email}}</div>-->
<!--        </div>-->
<!--        If you prefer to proceed with online payment, a third-party platform processing fee of <span style="color: #E95646;">${{cost}}</span> will be charged. The total amount is  <span style="color: #E95646">${{sub_total}}</span>.-->

<!--      </div>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <div style="margin-bottom: 16px">-->
<!--         <el-button type="danger" @click="PayAlertDialog = false" plain>Proceed to external payment</el-button>-->
<!--        </div>-->
<!--          <el-button type="primary" round  @click="openManuaHandle">Proceed to online payment</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->

<!--&lt;!&ndash;    客户端 设置手动支付方式&ndash;&gt;-->
<!--    <el-dialog-->
<!--      :modal="false"-->
<!--      title="Manually pay"-->
<!--      :visible.sync="manuaPayDialog"-->
<!--      top="5vh"-->
<!--      width="32%"-->
<!--    >-->
<!--      <div style="margin-bottom: 16px">-->
<!--        <creditPayform ref="manually_form"></creditPayform>-->
<!--      </div>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--         <el-button type="danger" @click="manuaPayDialog = false" plain>Cancel</el-button>-->
<!--          <el-button type="primary" round @click="manuallyPayconfirmHandle" >Save</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
//引入信用卡支付方式
// import creditPayform from "@/components/creditPayform";
import {getRpidiInfo, getStripeCost, payBill, printPdf, receiveApprove} from "@/api/bill";
export default {
  name: "billDetial",
  props: {
    info: {
      default: {}
    },
  },
  // components:{
  //   creditPayform
  // },
  data(){
    return{
      recieveDialog:false,
      approveDialog:false,
      manuaPayDialog:false,
      account:'',
      bill_table_data:[],
    }
  },
  created() {
    console.log(this.info,'status',this.info.status)
    this.bill_table_data = this.info.task
    this.account = JSON.parse(localStorage.getItem("userInfo")).type;

  },
  methods:{
    downInvoiceHandle(){
      printPdf({
        id:this.info.id
      }).then(res=>{
        if (res.code == 200){
          let baseUrl = process.env.VUE_APP_BASE_URL;
          let pdfurl = res.data.data
          // console.log( baseUrl + pdfurl)
          const newOpenWindow = window.open('about:blank')
          newOpenWindow.location = baseUrl + pdfurl
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:'error',
          message:'Failed to download'
        })
      })
    },
    manuallyPayHandle(){
      //打开手动付款弹框
      this.$emit('openAlert')
    },
    approveHandle(){
      // this.approveDialog = true
      this.$emit("approveBillHandle",this.info)
    },
    recieveHandle(){
      // this.recieveDialog = true
      this.$emit('recieveBillHandle',this.info)
    },
    recievePayHanlde(){
      this.recieveDialog = false
      receiveApprove({
        id:this.info.id
      }).then(res=>{
        if (res.code == 200){
          this.$emit('closeDetial')
          this.$message({
            type:'success',
            message:res.msg
          })
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:"error",
          message:err.msg
        })
      })
    }
  }
}
</script>

<style scoped lang="less">


.billDetial {
  position: relative;
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .pay_alert{
    color: #1F2D42;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin: 24px 0 48px;
  }
  position: relative;
  margin-top: 16px;

  .detail_out_box{
    display: flex!important;
    flex-direction: column!important;
    height: calc(100vh - 179px);
  }
  .detialInner {
    position: absolute;
    left: 66px;
    top: -44px;

    .changeStatus {
      color: #FFFFFF;
      padding: 0 24px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      font-size: 13px;
      font-weight: bold;
      color: #FFFFFF;
      background-color: red;
    }
  }
  .innerMes{
    //padding: 0 20px;
    text-align: left;

  }
  .paneOne{
    margin-bottom: 8px;
    /deep/.el-form-item__content{
      line-height: 34px;
    }
    /deep/.el-form-item__label{
      padding-right: 24px!important;
      margin: 8px 0;
    }
  }
  .out_btom_title{
    display: flex;
    justify-content: space-between;
  }
  .innerTable{
    //flex: 1;
    border-top: 1px solid #e0e0e0;
    //height: 26vh;
    overflow: auto;
    margin-bottom: 16px;
    /deep/.el-table td.el-table__cell{
      border: none!important;
    }
    /deep/.el-table .el-table__cell{
      height: 32px;
      padding:8px 0!important;
    }
    /deep/.el-table .cell{
      line-height: 20px !important;
    }
    /deep/.el-table__footer-wrapper{
      border-bottom: 1px solid #E0E0E0;
    }

  }
  .botm_box{
    padding-top: 14px;
    width: 100%;
    text-align: right;
    border-top: 1px solid #e0e0e0;
    /deepl/.el-button{
      border: 12px 24px;
    }
  }
}
/deep/.el-table .totalRow{
     td:first-child{
    font-weight: bold;
  }
}
/deep/.el-table .totalNum{
  td:first-child{
    font-weight: bold;
  }
  td:last-child{
    font-weight: bold;
    font-size: 18px;
  }
}
/deep/.el-table::before{
  height: 0;
}
/deep/.el-dialog__title{
  font-weight: bold;
}
/deep/.el-scrollbar__bar.is-horizontal{
  height: 0!important;
}
</style>
